module.exports = __webpack_public_path__ + "img/m_title.43c680df.png";